export default __webpack_public_path__ + "static/media/collaborate1.2e0fd95a.png";